import * as React from 'react';

import SyncArrows16 from './SyncArrows16';

export const syncArrows16 = () => <SyncArrows16 />;

export default {
    title: 'Icon/Line/SyncArrows16',
    component: SyncArrows16,
    parameters: {
        notes: "`import SyncArrows16 from 'box-ui-elements/es/icon/line/SyncArrows16';`",
    },
};
